export default class Faq {
	constructor() {
		this.$faq = $('.js-faq');
		this.$question = $('.js-faq-q');
		this.$answer = $('.js-faq-a');
		this.activeClass = 'js-is-active';
	}

	onClick(event) {
		const $elm = $(event.currentTarget);
		const $answer = $elm.closest(this.$faq).find(this.$answer);

		$elm.toggleClass(this.activeClass);
		$answer.slideToggle();
	}

	setEventBindings() {
		this.$question.on('click', this.onClick.bind(this));
	}

	init() {
		this.setEventBindings();
	}
}


// WEBPACK FOOTER //
// ./wp-content/themes/indiana811/source/scripts/components/Faq.js